module.exports = __webpack_public_path__ + "static/media/la-image.a7e7f88a.png";